import SubscriptionsSelector from '../SubscriptionsSelector'
import { Info } from '../uiLib'

export default ({ t, products, cart, subscription, addToCart, setSubscription, language, showAddPatsTip }) => (
  <div className="content">
    <div className="m-b-lg">
      <h4 className="is-size-4 m-b-md">{t('common:pats-page-subtitle')}</h4>      
      <div className="m-b-md">{t('common:pats-page-content-19')}</div>
      <p><a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Mazda_Software_Explained_Before_Purchase.pdf" target="_blank">{t('common:subscription-common')}</a></p>
      <div className="m-b-sm">{t('common:pats-page-content-1')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-2')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-3')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-4')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-13')}</div>
      <div className="m-b-sm">{t('common:pats-page-content-5')} <a href="https://wp.nastf.org" target="_blank">{t('common:click-here')}</a> {t('common:pats-page-content-15')}</div>
      
      <SubscriptionsSelector
        products={products}
        subscription={subscription}
        setSubscription={setSubscription}
        addToCart={addToCart}
        cart={cart}
        language={language}
        t={t} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/PATSCodes/index.js